enum ValuerInvoiceStatusEnum {
    AwaitingPayment = 'AWAITING_PAYMENT',
    Paid = 'PAID',
}

export default ValuerInvoiceStatusEnum;
